const player = new Plyr('#player', {
   
    invertTime: false,
    clickToPlay: true,
    playsinline: true,
    controls: [
        'play',
        'play-large',
        'current-time',
        'progress',
        'mute',
        'volume',
        'settings',
        'fullscreen',
    ],
    fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true,
    },
    speed: {
        selected: 1,
        options: [0.5, 0.75, 1, 1.5, 2],
    },
    captions: {
        active: false,
    },
});

document.addEventListener('DOMContentLoaded', () => {
    const leftBlock = document.querySelector('.mp-videoplayer__info--desktop');
    const playButtonDesktop = document.querySelector('.redBtn.desktop');
    const playButtonMobile = document.querySelector('.redBtn.mobile');
    const progressBar = document.querySelector('.plyr__progress');

    let isDragging = false;
    let suppressLeftBlock = false;

    function toggleLeftBlock() {
        if (!suppressLeftBlock && (player.fullscreen.active || player.playing)) {
            leftBlock.classList.add('mp-hidden');
        } else if (!isDragging && !player.playing) {
            leftBlock.classList.remove('mp-hidden');
        }
    }

    function handlePlay() {
        player.play();
        toggleLeftBlock();
    }

    playButtonDesktop?.addEventListener('click', handlePlay);
    playButtonMobile?.addEventListener('click', handlePlay);

    progressBar.addEventListener('mousedown', () => {
        isDragging = true;
        suppressLeftBlock = true;
    });

    progressBar.addEventListener('mouseup', () => {
        if (isDragging) {
            isDragging = false;
            setTimeout(() => {
                suppressLeftBlock = false;
                toggleLeftBlock();
            }, 300);
        }
    });

    player.on('fullscreenchange', toggleLeftBlock);
    player.on('play', toggleLeftBlock);
    player.on('pause', toggleLeftBlock);

    toggleLeftBlock();
});

function handleResize() {
    const mobileInfo = document.querySelector('.mp-videoplayer__info--mobile');
    const desktopInfo = document.querySelector('.mp-videoplayer__info--desktop');

    const isMobile = window.innerWidth <= 1000;

    desktopInfo.style.display = isMobile ? 'none' : 'flex';
    mobileInfo.style.display = isMobile ? 'flex' : 'none';
}

const video = document.querySelector('.plyr');
const customInfoBlock = document.createElement('div');
customInfoBlock.classList.add('mp-videoplayer__info--desktop');

customInfoBlock.innerHTML = `
    <div class="mp-videoplayer__info-layer">
        <p class="mp-videoplayer__preheading">
            I was skeptical about Maxi Pool tablet
        </p>
        <h2 class="mp-videoplayer__title">
            The Uniqueness of MaxiPool Tablets
        </h2>
        <p class="mp-videoplayer__subtitle">
            Watch our easy-to-follow guide on how to use our pool cleaning tablets.
        </p>
      <div class="mp-videoplayer__buttons">
            <button class="mp-videoplayer__button desktop redBtn">WATCH NOW</button>
            <a href="https://www.maxi-pool.com/products/maxi-pool-40-lbs-99-chlorine-for-pool-slow-dissolving-high-quality-trichlor"><button class="mp-videoplayer__button desktop">
                SHOP NOW
                <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.9375 1.6875L14.5625 7.3125M14.5625 7.3125L8.9375 12.9375M14.5625 7.3125L1.4375 7.3125" stroke="#0F8EC4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
            </button>
            </a>
        </div>
    </div>
`;

video.appendChild(customInfoBlock);

handleResize();
window.addEventListener('resize', handleResize);
